import { createModel } from "@rematch/core";

import type { RootModel } from ".";
import { PaginationFactory } from "../factory";
import { CustomerTypes } from "../types/customer.types";

/**
 * Store for admin management of ALL customers (POM Master only).
 * This is separate from the `customer` store which holds the current user's customer context.
 */
export interface CustomersAdminStoreProps {
    pagination: PaginationFactory<CustomerTypes.Model>,
    loading: {
        fetchMany: boolean,
        create: boolean,
    },
}

export const customersAdminInitialState: CustomersAdminStoreProps = {
    pagination: {} as PaginationFactory<CustomerTypes.Model>,
    loading: {
        fetchMany: false,
        create: false,
    },
};

export const customersAdmin = createModel<RootModel>()({
    state: customersAdminInitialState,
    reducers: {
        toggleLoading: (
            store, prop: keyof CustomersAdminStoreProps['loading'], v: boolean) => {
            store.loading[prop] = v;
        },
        setPagination: (store, pagination: PaginationFactory<CustomerTypes.Model>) => {
            store.pagination = pagination;
        },
        addPaginationItem: (store, item: CustomerTypes.Model) => {
            store.pagination.items = [...(store.pagination.items || []), item];
        },
    },
});
